import { BusinessClient } from "./business.js";
export class PartnersClient extends BusinessClient {
    async listPartners() {
        const res = await this.request("GET", "/v1/admin/partners", undefined, true);
        return res.partners ?? [];
    }
    async createPartner(input) {
        return this.request("POST", "/v1/admin/partners", input, true);
    }
    async getSitePartners(slug) {
        return this.request("GET", `/v1/admin/sites/${encodeURIComponent(slug)}/partners`, undefined, true);
    }
    async putSitePartners(slug, input) {
        return this.request("PUT", `/v1/admin/sites/${encodeURIComponent(slug)}/partners`, input, true);
    }
    async listPartnerLedger(slug, limit) {
        const q = new URLSearchParams();
        if (limit)
            q.set("limit", String(limit));
        return this.request("GET", `/v1/admin/partners/${encodeURIComponent(slug)}/ledger?${q.toString()}`, undefined, true);
    }
    async addPartnerLedgerEntry(slug, input) {
        return this.request("POST", `/v1/admin/partners/${encodeURIComponent(slug)}/ledger`, input, true);
    }
    /** Admin: re-run the partner split for one recorded Stripe hosting payment (idempotent). */
    async runPaymentSplit(slug, paymentId) {
        return this.request("POST", `/v1/admin/sites/${encodeURIComponent(slug)}/payments/${encodeURIComponent(paymentId)}/split`, undefined, true);
    }
    async getHostingStatus(slug) {
        return this.request("GET", `/v1/admin/sites/${encodeURIComponent(slug)}/hosting-status`, undefined, true);
    }
}
//# sourceMappingURL=partners.js.map